import { ethers } from "ethers";
import ABI_ARBITRUM_V3 from "./abi/ABI_ARBITRUM_V3";
import ABI_BSC_V3 from "./abi/ABI_BSC_V3";
import ABI_MATIC_V3 from "./abi/ABI_MATIC_V3";
import ABI_OPTIMISM_V3 from "./abi/ABI_OPTIMISM_V3";

const NETWORKS = {
  42161: {
    chainId: "0xA4B1",
    chainIdDec: 42161,
    dunePrefix:"arbitrum",
    chainName: "Arbitrum",
    contract: {
      abi: ABI_ARBITRUM_V3,
      address: "0x06633Dc1a9d0432D6F702f4fBb7861a1Fa109D31",
      houseEdgeMinimumAmount: ethers.BigNumber.from("100000000000000"),
      minJackpotBet: ethers.BigNumber.from("30000000000000000"),
      jackpotFee: ethers.BigNumber.from("300000000000000"),
      minBet: ethers.BigNumber.from("1000000000000000"),
      maxAmount: ethers.BigNumber.from("300000000000000000000000"),
    },
    ui: {
      gradient: "linear-gradient(86.38deg, #28A0F0 3.92%, #0678C4 99.17%);",

      decimals: 3,
      betInput: 0.01,
      steps: 0.01,
      menuIcon: "/img/logos/arbitrum-transparent.svg",
      menuIcon2: "/img/logos/arbitrum-transparent.svg",
      curIconUrl: "/img/logos/ethereum.svg",
      symbol: "ETH",
      explorerUrl: "https://arbiscan.io",
      duneUrl: "https://dune.com/nice2win/nice2win-casino-arbitrum",
    },
    wallet_addEthereumChain: {
      chainId: "0xA4B1",
      rpcUrls: ["https://arb1.arbitrum.io/rpc"],
      chainName: "Arbitrum Mainnet",
      nativeCurrency: { name: "ETH", decimals: 18, symbol: "ETH" },
      blockExplorerUrls: ["https://arbiscan.io"],
    },
  },
  56: {
    chainId: "0x38",
    chainIdDec: 56,
    dunePrefix:"bsc",
    chainName: "BNB Chain",
    contract: {
      abi: ABI_BSC_V3,
      gradient: "linear-gradient(73.28deg, #403C3C 6.51%, #403721 88.45%);",

      address: "0x478b3c6cf6176295DF822F24c3fA42487CF6d734",
      houseEdgeMinimumAmount: ethers.BigNumber.from("1000000000000000"),
      minJackpotBet: ethers.BigNumber.from("50000000000000000"),
      jackpotFee: ethers.BigNumber.from("5000000000000000"),
      minBet: ethers.BigNumber.from("50000000000000000"),
      maxAmount: ethers.BigNumber.from("300000000000000000000000"),
    },
    ui: {
      gradient: "linear-gradient(73.28deg, #403C3C 6.51%, #403721 88.45%);",
      decimals: 3,
      betInput: 0.05,
      steps: 0.05,
      menuIcon: "/img/logos/bsc.svg",
      menuIcon2: "/img/logos/bsc.svg",
      curIconUrl: "/img/logos/bsc.svg",
      symbol: "BNB",
      explorerUrl: "https://www.bscscan.com",
      duneUrl: "https://dune.com/nice2win/nice2win-casino-bsc",
    },
    wallet_addEthereumChain: {
      chainId: "0x38",
      rpcUrls: ["https://bsc-dataseed1.ninicoin.io"],
      chainName: "Binance Smart Chain Mainnet",
      nativeCurrency: { name: "BNB", decimals: 18, symbol: "BNB" },
      blockExplorerUrls: ["https://bscscan.com/"],
    },
  },
  137: {    
    chainId: "0x89",
    chainIdDec: 137,
    dunePrefix:"polygon",
    chainName: "Polygon",
    contract: {
      abi: ABI_MATIC_V3,
      address: "0x28b564c1fF243970d8d67E440e03E060517ff54C",
      houseEdgeMinimumAmount: ethers.BigNumber.from("100000000000000000"),
      minJackpotBet: ethers.BigNumber.from("30000000000000000000"),
      jackpotFee: ethers.BigNumber.from("300000000000000000"),
      minBet: ethers.BigNumber.from("1000000000000000000"),
      maxAmount: ethers.BigNumber.from("300000000000000000000000"),
    },
    ui: {
      gradient: "linear-gradient(73.28deg, #8247E5 6.51%, #6027C0 88.45%);",
      decimals: 2,
      betInput: 5,
      steps: 1,
      menuIcon: "/img/logos/polygon-transparent.svg",
      menuIcon2: "/img/logos/polygon.svg",
      curIconUrl: "/img/logos/polygon.svg",
      symbol: "MATIC",
      explorerUrl: "https://polygonscan.com",
      duneUrl: "https://dune.com/nice2win/nice2win-casino-polygon",
    },
    wallet_addEthereumChain: {
      chainId: "0x89",
      rpcUrls: ["https://polygon-rpc.com/"],
      chainName: "Polygon Mainnet",
      nativeCurrency: { name: "MATIC", decimals: 18, symbol: "MATIC" },
      blockExplorerUrls: ["https://polygonscan.com/"],
    },
  },
  10: {    
    chainId: "0xA",
    chainIdDec: 10,
    dunePrefix:"optimism",
    chainName: "Optimism",
    contract: {
      abi: ABI_OPTIMISM_V3,
      address: "0xbbf2120f44229674418c41dA25Ee713aa4464c5F",
      houseEdgeMinimumAmount: ethers.BigNumber.from("100000000000000"),
      minJackpotBet: ethers.BigNumber.from("30000000000000000"),
      jackpotFee: ethers.BigNumber.from("300000000000000"),
      minBet: ethers.BigNumber.from("1000000000000000"),
      maxAmount: ethers.BigNumber.from("300000000000000000000000"),
    },
    ui: {
      gradient: "linear-gradient(73.28deg, #FF0420 6.51%, #C10A1F 88.45%);",
      decimals: 3,
      betInput: 0.01,
      steps: 0.01,
      menuIcon: "/img/logos/optimism-transparent.svg",
      menuIcon2: "/img/logos/optimism.svg",
      curIconUrl: "/img/logos/ethereum.svg",
      symbol: "ETH",
      explorerUrl: "https://optimistic.etherscan.io",
      duneUrl: "https://dune.com/nice2win/nice2win-casino-optimism",
    },
    wallet_addEthereumChain: {
      chainId: "0xA",
      rpcUrls: ["https://mainnet.optimism.io/"],
      chainName: "Optimistic Ethereum",
      nativeCurrency: { name: "ETH", decimals: 18, symbol: "ETH" },
      blockExplorerUrls: ["https://optimistic.etherscan.io/"],
    },
  },
};

export default NETWORKS;